
import { Outlet } from "react-router-dom";


const WithoutHeaderLayout = () => {
  return (
    <div>
      {/* Only render the child components */}
      <Outlet />
    </div>
  );
};

export default WithoutHeaderLayout;
